import Cookies from 'universal-cookie';

const getUserIpAddress: () => Promise<string> = async () => {
  try {
    const response = await fetch('https://api64.ipify.org?format=json');
    const data = await response.json();

    return data.ip;
  } catch (error) {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();

    return data.ip;
  }
};

const getCookie = (name: string): string | null => {
  const cookies = new Cookies();

  return cookies.get(name) || null;
};

const hashEmail = async (email: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(email.toLowerCase().trim());
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return hashHex;
};

export { getCookie, getUserIpAddress, hashEmail };
